import { ELinxConnectionMethod, PaymentMethodType } from 'vopay';

export const paymentMethodToElinxConnectionMethodMap: Record<PaymentMethodType, ELinxConnectionMethod> = {
  BankAccount: 'bank',
  CreditCard: 'credit',
  DebitCard: 'debitcard',
  PhoneNumber: 'email',
  Email: 'email',
  GooglePay: 'googlepay',
  ApplePay: 'applepay',
  PayPal: 'paypal',
  Venmo: 'venmo',
};
